<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">Delete selected profile?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected profile.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn
                color="accent"
                flat
                @click="deleteApprovalProfileById"
                :loading="isLoading"
                :disable="isLoading"
              >delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>
    <!-- Upload dialog form -->
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="uploadDialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Upload New Approval Limits</v-card-title>
            <v-container>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Select file"
                      @click="pickFile"
                      v-model="fileName"
                      prepend-icon="attach_file"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      label="Please choose your CSV file"
                      accept=".csv"
                      ref="fileInput"
                      required
                      @change="onFileChanged"
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="uploadDialog = false">cancel</v-btn>
              <v-btn
                color="accent"
                flat
                @click="uploadFile"
                :loading="isLoading"
                :disable="isLoading"
              >upload</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>
    <!-- End of Upload dialog form -->
    <!-- New/Change dialog form -->
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialogForm" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">New Approval Limit</v-card-title>
            <v-container>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      type="number"
                      v-model.number="limit.min_value"
                      label="Min. Limit"
                      :error-messages="errors.collect('min limit')"
                      v-validate="'required|numeric'"
                      data-vv-name="min limit"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      type="number"
                      v-model.number="limit.max_value"
                      label="Max. Limit"
                      :error-messages="errors.collect('max limit')"
                      v-validate="'required|numeric'"
                      data-vv-name="max limit"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      label="Unlimited"
                      v-model="limit.is_unlimited"
                      light
                      true-value="1"
                      false-value="0"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialogForm = false">cancel</v-btn>
              <v-btn
                color="accent"
                flat
                @click="addNewLimit"
                :loading="isLoading"
                :disable="isLoading"
              >save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>
    <!-- End of New/Change dialog form
    -->
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Details</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <v-card-title>
            <v-btn dark color="accent" @click="dialogForm = true">new</v-btn>
            <!-- <v-btn dark color="accent" @click="uploadDialog = true">
              <v-icon left dark>cloud_upload</v-icon>Upload
            </v-btn>-->
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :loading="isLoading"
            v-bind:headers="headers"
            v-bind:items="getApprovalLimits.items"
            v-bind:search="search"
            v-model="selected"
            item-key="id"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <!-- <td class="text-xs-left">
                <v-tooltip bottom>
                  <v-btn
                    flat
                    icon
                    @click="editPlantById(props.item.id)"
                    color="accent lighten-1"
                    slot="activator"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Change</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    flat
                    icon
                    @click="toggleDialog(props.item.id)"
                    color="error lighten-1"
                    slot="activator"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </td>-->
              <td class="text-xs-left">{{ props.item.id}}</td>
              <td class="text-xs-right">{{ props.item.string_value}}</td>
              <td class="text-xs-right">{{ props.item.min_value | currency}}</td>
              <td
                class="text-xs-right"
              >{{ props.item.max_value === 0 ? 'Unlimited' : $options.filters.currency(props.item.max_value) }}</td>
            </template>
          </v-data-table>

          <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
            {{ text }}
            <v-btn flat dark @click.native="snackbar = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Papa from 'papaparse'

export default {
  name: 'limit-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      dialogForm: false,
      uploadDialog: false,
      csvFile: '',
      fileName: '',
      limit: {
        min_value: '',
        max_value: '',
        is_unlimited: false
      },
      types: [
        { type: 'PR', description: 'Purchase requisition' },
        { type: 'PO', description: 'Purchase order' }
      ],
      rowsPerPageItems: [10, 15, 20],
      headers: [
        // {
        //   text: 'Actions',
        //   align: 'left',
        //   value: 'actions',
        //   sortable: false
        // },
        {
          text: 'ID',
          align: 'left',
          value: 'id'
        },
        {
          text: 'Description',
          align: 'right',
          value: 'string_value'
        },
        {
          text: 'Min value',
          align: 'right',
          value: 'min_value'
        },
        {
          text: 'Max value',
          align: 'right',
          value: 'max_value'
        }
      ],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions([
      'addApprovalLimit',
      'deleteApprovalProfile',
      'fetchApprovalLimits',
      'uploadApprovalLimit'
    ]),

    // getDescription(from, to) {
    //   let text = ''
    //   if (from === 0 && to !== 0) {
    //     text = '<= ' + this.$options.filters.currency(to)
    //   } else if (from === 0 && to === 0) {
    //     text = '>= ' + this.$options.filters.currency(from)
    //   } else if (from > 0 && to !== 0) {
    //     text =
    //       '> ' +
    //       this.$options.filters.currency(from) +
    //       ' - ' +
    //       this.$options.filters.currency(to)
    //   } else if (from > 0 && to === 0) {
    //     text = '> ' + this.$options.filters.currency(from)
    //   } else {
    //     // future condition
    //   }
    //   return text
    // },

    addNewLimit: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addApprovalLimit(this.limit).then(() => {
            this.dialogForm = false
            // let response = this.getResponse
            // this.snackbar = true
            // this.text =
            //   response.status === 200
            //     ? 'Added successfully.'
            //     : 'Sorry, something went wrong.Please try again.'
            // this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },

    pickFile() {
      this.$refs.fileInput.click()
    },

    onFileChanged(event) {
      const files = event.target.files
      this.csvFile = files[0]
      this.fileName = files[0].name
    },

    uploadFile() {
      Papa.parse(this.csvFile, {
        header: true,
        skipEmptyLines: true,
        complete: results => {
          console.log(results.data)
          this.uploadApprovalLimit(results.data)
            .then(response => {
              this.uploadDialog = false
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },

    // addProfile: function() {
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       this.addApprovalProfile(this.profile).then(() => {
    //         this.dialogForm = false
    //         let response = this.getResponse
    //         this.snackbar = true
    //         this.text =
    //           response.status === 200
    //             ? 'Added successfully.'
    //             : response.data.message
    //         this.color = response.status === 200 ? 'success' : 'error'
    //       })
    //     }
    //   })
    // },

    // editPlantById: function(id) {
    //   this.$router.push({ name: 'changeLimit', params: { id: id } })
    // },

    toggleDialog: function(id) {
      this.selectedId = id
      this.dialog = true
    },

    deleteApprovalProfileById: function() {
      this.deleteApprovalProfile(this.selectedId).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    }
  },
  mounted: function() {
    this.fetchApprovalLimits()
  },
  computed: {
    ...mapGetters({
      isLoading: 'getLoading',
      getResponse: 'getResponse',
      getApprovalLimits: 'getApprovalLimits',
      getApprovalLimitWithText: 'getApprovalLimitWithText'
    })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="stylus" scoped>
div {
  text-align: center;
}

.progress-circular {
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/approval-limit/LimitDetail.vue